<template>
  <div class="w-full max-w-4xl mx-auto flex flex-wrap px-4 py-6 mt-16 bg-grey-0">
    <div class="w-full md:w-1/4">
      <user-avatar-form :user="user" @success="fetch"></user-avatar-form>
    </div>
    <div class="w-full md:w-3/4 md:pl-4">
      <user-update-form :user="user" @success="fetch"></user-update-form>
      <div class="text-center">
        <nx-button type="danger" native-type="button" @click="show.delete = true">Delete My Account</nx-button>
      </div>
    </div>

    <portal to="modal-portal">
      <prompt v-if="show.delete" @close="show.delete = false" @confirm="deleteSelf">
        This will delete your account and all your threads and replies. This cannot be undone.
        <br />Are you sure?
      </prompt>
    </portal>

    <portal to="breadcrumb-portal">
      <breadcrumbs>
        <router-link class="breadcrumb-link" :to="{name: 'channels.index'}">Home</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-current">Your Profile</span>
      </breadcrumbs>
    </portal>
  </div>
</template>

<script>
import UserUpdateForm from "@/components/Forms/UserUpdateForm"
import UserAvatarForm from "@/components/Forms/UserAvatarForm"
import { ChevronRightIcon } from "vue-feather-icons"

export default {
  name: "Profile",
  components: {
    UserUpdateForm,
    UserAvatarForm,
    ChevronRightIcon
  },
  data() {
    return {
      user: this.$auth.user(),
      show: {
        delete: false
      }
    }
  },
  methods: {
    deleteSelf() {
      this.show.delete = false
      this.$api.self
        .destroy()
        .then(() => {
          this.$toasted.success(
            "Your account has been deleted and you have been logged out."
          )
          this.$auth.logout()
          this.$router.push({ name: "channels.index" })
        })
        .catch(() => {
          this.$error.generic()
        })
    },
    fetch() {
      this.$auth.fetch().then(() => (this.user = this.$auth.user()))
    }
  }
}
</script>
